module.exports = __webpack_public_path__ + "static/productsans-medium-webfont-3a76aa0eb110ffcae8e6d89a0250ed12.woff";